// This component dynamically loads an external tracking script.
// If the main script fails to load, it loads a fallback script instead.
// We use useEffect to ensure the script runs only once after the component mounts.
'use client';
import { useEffect } from 'react';

const SMSAttentiveLoader = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://jkbfu.americangolf.co.uk/providers/atLabel/load';
    script.async = true;

    // If the main script fails, load the fallback
    script.onerror = () => {
      const fallbackScript = document.createElement('script');
      fallbackScript.src = 'https://cdn.attn.tv/americangolf/dtag.js';
      fallbackScript.async = true;
      document?.head?.appendChild(fallbackScript);
    };

    document?.head?.appendChild(script);
  }, []);

  return null;
};

export default SMSAttentiveLoader;
